const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

function loadGoogleAnalytics() {
  if (!GA_MEASUREMENT_ID || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

function trackPageView(to) {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  const pagePath = to.path || "/";

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${pagePath}`,
    page_path: pagePath,
  });
}

export function installAnalytics(router) {
  if (!GA_MEASUREMENT_ID || typeof window === "undefined") return;

  loadGoogleAnalytics();

  router.afterEach((to, _from, failure) => {
    if (failure) return;
    trackPageView(to);
  });
}
